<template>
  <div class="container">
    <Header :banner="require('@/assets/images/banner/home.png')" />
    <section class="section section1">
      <div class="short_line"></div>
      <h1 class="font-size-22 font-blod text-center mb30">探索追求之目标</h1>
      <div class="fa box-center percent80">
        <div
          class="img-box percent20 pointer"
          v-for="(item, index) in section1"
          :key="index"
        >
          <img :src="item.img" class="img" />
          <div class="title text-center percent100 fcc font-size-20 c_fff">
            {{ item.label }}
          </div>
          <div class="shade"></div>
        </div>
      </div>
    </section>
    <section class="section section2">
      <div class="short_line"></div>
      <h1 class="font-size-22 font-blod text-center mb50">自主产权之云台</h1>
      <div class="fa navBar pointer mb50">
        <span
          class="pb20"
          :class="{ active: choiceSection2Nav === 1 }"
          @click="choiceSection2Nav = 1"
          >APP商城</span
        >
        <span
          class="pb20"
          :class="{ active: choiceSection2Nav === 2 }"
          @click="choiceSection2Nav = 2"
          >微信商城</span
        >
        <span
          class="pb20"
          :class="{ active: choiceSection2Nav === 3 }"
          @click="choiceSection2Nav = 3"
          >小程序</span
        >
        <span
          class="pb20"
          :class="{ active: choiceSection2Nav === 4 }"
          @click="choiceSection2Nav = 4"
          >考核培训H5</span
        >
        <span
          class="pb20"
          :class="{ active: choiceSection2Nav === 5 }"
          @click="choiceSection2Nav = 5"
          >PC商城</span
        >
      </div>
      <div>
        <img
          v-if="choiceSection2Nav === 1"
          :src="require('@/assets/images/home/app market.png')"
          alt="APP商城"
          class="img"
        />
        <img
          v-if="choiceSection2Nav === 2"
          :src="require('@/assets/images/home/wx market.png')"
          alt="微信商城"
          class="img"
        />
        <img
          v-if="choiceSection2Nav === 3"
          :src="require('@/assets/images/home/wx_1.png')"
          alt="小程序"
          class="img"
        />
        <img
          v-if="choiceSection2Nav === 4"
          :src="require('@/assets/images/home/assessment.png')"
          alt="考核培训H5"
          class="img"
        />
        <img
          v-if="choiceSection2Nav === 5"
          :src="require('@/assets/images/home/pc market.png')"
          alt="PC商城"
          class="img"
        />
      </div>
    </section>
    <section class="fcol section section3 pt200">
      <div
        class="short_line"
        style="background-color: rgb(255, 255, 255)"
      ></div>
      <h1 class="font-size-22 font-blod text-center mb50 c_fff">
        傲立领域之优势
      </h1>
      <div class="list f1 fcol percent80 box-center font-size-18">
        <div class="fa">
          <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/1.png')"
                alt="实力顶尖"
                class="img percent10 box-center mb20"
              /><span>实力顶尖</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              上海市高新技术企业，上海市软件企业，上海市软件行业协会成员，拥有数十余项发明专利及著作权。
            </div>
          </div>
          <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/2.png')"
                alt="信誉优良"
                class="img percent10 box-center mb20"
              /><span>信誉优良</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              与相关政府机关、企业单位、金融学校等均拥有良好的合作基础，合作历程长达十余年之久。
            </div>
          </div>
          <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/6.png')"
                alt="平台依托"
                class="img percent10 box-center mb20"
              /><span>平台依托</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              在十余年开发经验积累下，形成了拥有自主知识产权的稳定开发平台，并在许多案例中实施并得以成功。
            </div>
          </div>
        </div>
        <div class="fa">
          <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/5.png')"
                alt="成本优势"
                class="img percent10 box-center mb20"
              /><span>成本优势</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              久经考验的开发平台加上洞悉未来的技术实力，极大程度降低了客户的开发成本，提升客户的收益效率，终将实现自身与客户间的双赢局面。
            </div>
          </div>
          <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/4.png')"
                alt="售前策划"
                class="img percent10 box-center mb20"
              /><span>售前策划</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              为客户提供售前策划、咨询服务，协助客户共同进行业务的需求分析过程，即保证了客户的最终期望值的完美体现，也增进了与客户共同发展的合作基础。
            </div>
          </div>
          <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/3.png')"
                alt="管理领先"
                class="img percent10 box-center mb20"
              /><span>管理领先</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              健全的项目管理制度，成熟的项目管理工具，领先的项目管理理念，是确保项目顺利完成的必要条件，自主研发的Helpdesk项目管理工具是悟之100%项目成功的保障，完美诠释了管理至上的理念。
            </div>
          </div>

          <!-- <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/4.png')"
                alt="服务优质"
                class="img percent10 box-center mb20"
              /><span>服务优质</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              如果说雄厚的技术是一个APP开发公司的硬实力，那么优质的服务就是其软实力的体现，APP开发前期的沟通往往需要甲乙双方的沟通配合才能完成。
            </div>
          </div> -->
          <!-- <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/5.png')"
                alt="成本降低"
                class="img percent10 box-center mb20"
              /><span>成本降低</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              技术优势降低开发成本，iOS、Android同时开发，共享一套代码，维护、升级成本低。
            </div>
          </div> -->
          <!-- <div class="percent20 fcol c_fff">
            <div class="f1 fcol text-center mb20">
              <img
                :src="require('@/assets/img/icon/6.png')"
                alt="平台稳妥"
                class="img percent10 box-center mb20"
              /><span>平台稳妥</span>
            </div>
            <div class="content f2 font-size-14 text-center">
              市场上服务商众多，鱼龙混杂，很多外包公司只做一锤子买卖，售后不完善，出问题推卸责任，而稳妥的平台监管商家，项目交付质量高。
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <section class="section4 section mb50">
      <div class="short_line"></div>
      <h1 class="font-size-22 font-blod text-center mb50">
        客户至上之服务
      </h1>
      <div class="fcol serve percent80 box-center">
        <div class="fa mb100">
          <div class="percent20 fcol fcc">
            <img
              :src="require('@/assets/img/icon/7.png')"
              alt=""
              class="img mb30 percent20"
            /><span >热线支持服务</span>
          </div>
          <div class="percent20 fcol fcc">
            <img
              :src="require('@/assets/img/icon/8.png')"
              alt=""
              class="img mb30 percent20"
            /><span >专人接口服务</span>
          </div>
          <div class="percent20 fcol fcc">
            <img
            :src="require('@/assets/img/icon/9.png')"
              alt=""
              class="img mb30 percent20"
            /><span >支持现场服务</span>
          </div>
        </div>
        <div class="fa">
          <div class="percent20 fcol fcc">
            <img
              :src="require('@/assets/img/icon/10.png')"
              alt=""
              class="img mb30 percent20"
            /><span >定期巡查服务</span>
          </div>
          <div class="percent20 fcol fcc">
            <img
              :src="require('@/assets/img/icon/11.png')"
              alt=""
              class="img mb30 percent20"
            /><span >用户档案维护服务</span>
          </div>
          <div class="percent20 fcol fcc">
            <img
              :src="require('@/assets/img/icon/12.png')"
              alt=""
              class="img mb30 percent20"
            /><span >增值服务</span>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
export default {
  data() {
    return {
      section1: [
        {
          img: require('@/assets/images/home/ai.png'),
          label: "智能 AI",
        },
        {
          img: require('@/assets/images/home/mobile application.png'),
          label: "移动应用",
        },
        {
          img: require('@/assets/images/home/enterprise collaboration.png'),
          label: "企业协作",
        },
        {
          img: require('@/assets/images/home/financial data.png'),
          label: "金融数据",
        },
      ],
      choiceSection2Nav: 1,
    };
  },
  components: {
    Header,
    Footer
  },
};
</script>

<style lang="scss" scoped>
.container {
  .section1 {
    .img-box {
      position: relative;
      overflow: hidden;
      padding-bottom: 5%;
      display: flex;
      flex-direction: column;
      .shade {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 20%;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
      }
      .title {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 20%;
        background-color: #166daf;
      }
      &:hover {
        .shade {
          display: block;
        }
      }
    }
  }
  .section2 {
    .navBar {
      padding: 0 5%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      font-size: 18px;
      & > span {
        position: relative;
        top: 1px;
        &.active {
          color: #166daf;
          border-bottom: 1px solid #166daf;
        }
        &:hover {
          color: #166daf;
          border-bottom: 1px solid #166daf;
        }
      }
    }
  }
  .section3 {
    height: 760px;
    background-image: url(~@/assets/images/home/bg.png);
    background-size: 100% 100%;
    .list {
      & > div {
        height: 42%;
        .content {
          line-height: 25px;
          text-align: left;
        }
      }
    }
  }
  .section4 {
    font-size: 18px;
  }
}
</style>